var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-field-component"},_vm._l((_vm.assets),function(asset){return (_vm.assets.length)?_c('preview-card',{key:asset.asset_id,staticClass:"active-border pointer",attrs:{"ownerName":asset.owner,"data":asset,"small":_vm.smallCards || _vm.assets.length > 1},on:{"click":function($event){return _vm.remove(asset)}}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }